const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";

const getAuthHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

const getJsonHeaders = () => ({
  ...getAuthHeaders(),
  "Content-Type": "application/json",
});

async function handleResponse(response) {
  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || "Greška pri dohvaćanju logova.");
  }
  return response.json();
}

function buildParams(pageNumber, pageSize, filter = {}) {
  const params = new URLSearchParams({ pageNumber: String(pageNumber), pageSize: String(pageSize) });
  if (filter.agentName)    params.set("agentName",    filter.agentName);
  if (filter.activityType) params.set("activityType", filter.activityType);
  if (filter.search)       params.set("search",       filter.search);
  if (filter.dateFrom)     params.set("dateFrom",     filter.dateFrom);
  if (filter.dateTo)       params.set("dateTo",       filter.dateTo);
  return params;
}

export async function fetchLogsForAgent(agentId, pageNumber = 1, pageSize = 20, filter = {}) {
  const params = buildParams(pageNumber, pageSize, filter);
  const response = await fetch(
    `${API_BASE_URL}/api/ActivityLog/agent/${encodeURIComponent(agentId)}?${params}`,
    { headers: getAuthHeaders() }
  );
  return handleResponse(response);
}

export async function fetchAllLogs(pageNumber = 1, pageSize = 20, filter = {}) {
  const params = buildParams(pageNumber, pageSize, filter);
  const response = await fetch(
    `${API_BASE_URL}/api/ActivityLog?${params}`,
    { headers: getAuthHeaders() }
  );
  return handleResponse(response);
}

export async function fetchLogFilterOptions() {
  const response = await fetch(`${API_BASE_URL}/api/ActivityLog/filter-options`, {
    headers: getAuthHeaders(),
  });
  return handleResponse(response);
}

export async function logPrint(printRequest) {
  const response = await fetch(`${API_BASE_URL}/api/ActivityLog/print`, {
    method: "POST",
    headers: getJsonHeaders(),
    body: JSON.stringify(printRequest),
  });
  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || "Greška pri logiranju ispisa.");
  }
}
